<template>
  <!-- Usage : <Countdown starttime="2019-03-10 12:00:00" endtime="2019-03-11 12:00:00" /> -->
  <div class='countdown-plp-wrapper'  :class="{'countdown-cart-wrapper': callerComp==='cart', 'countdown-imgblock-wrapper': callerComp==='imgBlock'}">
    <div class="text-center" v-if="showEarlyText">
      <span class="pretext"> {{this.pretext}}</span>
    </div>
    <div
      :class="secondUI ? 'timer1' :  mobileUI ? 'mobile-ui' : 'timer'"
      :style="`color: ${color ? color : '#333'}`"
      class="text-center"
      v-if="this.now < this.endtime"
    >
      <span class="pretext" v-if="(this.now >= this.starttime && this.now < this.endtime && this.pretext && !showEarlyText && !secondUI && !mobileUI)"> {{this.pretext}} </span>
      <span class="pretext1" v-if="(this.now >= this.starttime && this.now < this.endtime && this.pretext && !showEarlyText && secondUI || mobileUI)"> {{this.pretext}} </span>
      <span style="font-size: 0.63em" v-else-if="this.now > this.endtime">
        {{this.successtext}}
      </span>
      <slot />
      <div class="countdown" v-if="this.now >= this.starttime && this.now < this.endtime && showTimer && !secondUI && !mobileUI">
        <div class="time">
          <p class="number">{{ days | twoDigits }}</p>
          <p class="unit">days :</p>
        </div>
        <div class="time">
          <p class="number">{{ hours | twoDigits }}</p>
          <p class="unit">hrs :</p>
        </div>
        <div class="time">
          <p class="number">{{ minutes | twoDigits }}</p>
          <p class="unit">min :</p>
        </div>
        <div class="time" ref="seconds">
          <p class="number">{{ seconds | twoDigits }}</p>
          <p class="unit">sec</p>
        </div>
      </div>
      <div class="countdown" style="padding-top: 0px" v-if="this.now >= this.starttime && this.now < this.endtime && showTimer && secondUI">
        <div class="time1">
          <span class="number1">{{ days | twoDigits }}</span>
          <div class="unit1 text-uppercase">day</div>
        </div>
        <span class="two-dot">:</span>
        <div class="time1">
          <span class="number1">{{ hours | twoDigits }}</span>
          <div class="unit1 text-uppercase">hr</div>
        </div>
        <span class="two-dot">:</span>
        <div class="time1">
          <span class="number1">{{ minutes | twoDigits }}</span>
          <div class="unit1 text-uppercase">min</div>
        </div>
        <span class="two-dot">:</span>
        <div class="time1" ref="seconds">
          <span class="number1">{{ seconds | twoDigits }}</span>
          <div class="unit1 text-uppercase">sec</div>
        </div>
      </div>
      <div class="mobileUI countdown pt-0 pb-2" v-if="this.now >= this.starttime && this.now < this.endtime && showTimer && mobileUI">
        <span class="number1">{{ days | twoDigits }} <span class="timerFormat">{{(days) > 1 ? 'days' : 'day' }} : </span>{{ hours | twoDigits }} <span class="timerFormat">hrs : </span>{{ minutes | twoDigits }} <span class="timerFormat">min : </span>{{ seconds | twoDigits }} <span class="timerFormat">sec</span></span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['starttime', 'endtime', 'color', 'successtext', 'pretext', 'disappeartime', 'showEarlyText', 'showTimer', 'secondUI', 'callerComp', 'days', 'minutes', 'hours', 'seconds', 'now', 'mobileUI'],
  data: function () {
    return {}
  },
  filters: {
    twoDigits (value) {
      return value.toString().padStart(2, '0')
    }
  }
}
</script>
<style scoped>
  .countdown {
    display: flex;
    justify-content: center;
  }
  .pretext {
    color: #282d3f;
    font-weight: 600;
    display: inline-block;
    font-size: 24px;
    width: 100%;
    margin-bottom: unset;
  }
  .countdown-cart-wrapper .pretext {
    font-size: 16px;
    font-weight: normal;
  }
  .countdown-imgblock-wrapper .pretext {
    font-size: 12px;
  }
  .countdown-plp-wrapper {
    padding: 10px 0px;
    background-color: #ededef;
  }
  .countdown-cart-wrapper {
    background-color: #fcf2f0;
    margin-top: 16px;
  }
  .countdown-imgblock-wrapper {
    padding: 3px 0px;
    background-color: #ffffff;
    opacity: 0.8;
    width: 100%;
  }
  .timer {
    font-size: 40px;
    color: #333;
    margin: 15px auto 0;
    display: flex;
    flex-direction: column;
    margin-top: 0px;
  }
  .countdown-imgblock-wrapper .countdown {
    gap: 7px;
  }
  .countdown-cart-wrapper .timer{
    font-size: 17px;
     color: #282d3f;
  }
  .countdown-imgblock-wrapper .timer {
    font-size: 16px;
    color: #282d3f;
  }
  .timer1 {
    font-size: 60px;
    color: #333;
    margin: 15px auto 0;
    display: flex;
    flex-direction: column;
  }
  .time {
    display: inline-block;
    display: flex;
    justify-content: center;
    align-items: baseline;
    margin: 0 15px;
  }
  .countdown-cart-wrapper .time{
    margin: unset;
  }
  .countdown-imgblock-wrapper .time{
    margin: unset;
    gap: 5px;
  }
  .time p{
    margin-bottom: unset;
  }
  .unit {
    font-weight: 300;
    font-size: 25px;
    color: #707070;
    font-weight: 600;
    margin-bottom: 20px;
  }
  .countdown-cart-wrapper .unit{
    font-size: 12px;
    font-weight: normal;
  }
  .countdown-imgblock-wrapper .unit {
    font-size: 9px;
    color: #282d3f;
    font-weight: normal;
  }
  .number {
    color: #ed2d2f;
    font-weight: bold;
    display: inline-block;
    padding:  0px 7px;
    position: relative;
  }
  .countdown-cart-wrapper .number{
    font-weight: normal;
    padding: 0px 4px;
  }
  .countdown-imgblock-wrapper .number {
    padding: unset;
  }
  .time1 {
    display: inline-block;
    margin: 0 15px;
    text-align: center;
    font-size: 44px;
  }
  .number1 {
    color: #ed2d2f;
    font-weight: bold;
    display: inline-block;
    padding:  0px 10px;
    position: relative;
  }
  .two-dot {
    color: #ed2d2f;
    font-size: 44px;
    font-weight: 600;
  }
  .unit1 {
    font-size: 20px;
    color: #282d3f;
    margin-bottom: 20px;
    font-weight: 600;
  }
  .pretext1 {
    display: inline-block;
    margin: 10px 0;
    width: 100%;
    font-size: 20px;
    color: #282d3f;
    font-weight: 600;
  }
  @media screen and (max-width: 768px) {
    .pretext, .pretext1 {
      font-size: 18px;
    }
   .number {
    padding:  0px 10px;
   }
   .time {
      margin: 0 10px;
    }
    .unit {
      font-size: 20px;
    }
    .mobileUI .number1 {
      font-size: 18px !important;
      font-weight: normal;
    }
    .mobile-ui .pretext1 {
      font-weight: normal;
      font-size: 14px;
      margin: 10px 0 0 0 !important;
    }
    .timerFormat {
      font-size: 14px;
      color: #7c7c7c;
    }
  }

  @media screen and (max-width: 480px) {
    .pretext {
       margin-bottom: 8px;
    }
    .countdown-cart-wrapper .pretext {
      font-size: 14px;
    }
    .countdown-imgblock-wrapper .pretext{
      margin-bottom: 3px;
      font-size: 10px;
    }
    .pretext1 {
      font-size: 16px;
    }
    .number {
      padding: 0px 5px;
    }
    .time {
      margin: 0 6px;
      display: flex;
    }
    .time1 {
      font-size: 35px;
      margin: 0 10px;
    }
    .timer {
      font-size: 35px;
      line-height: 1;
    }
    .countdown-cart-wrapper .timer {
      font-size: 15px;
    }
    .countdown-imgblock-wrapper .timer {
      font-size: 11px;
    }
    .countdown-imgblock-wrapper .unit {
      font-size: 9px;
    }
    .countdown-imgblock-wrapper .time {
      gap: 2px;
    }
    .timer1 {
      font-size: 45px;
      line-height: 1;
    }
    .unit, .unit1 {
      font-size: 13px;
    }
    .two-dot {
      font-size: 35px;
    }
    .countdown-plp-wrapper {
      margin-top: unset;
      padding: 0;
    }
    .countdown-cart-wrapper {
      padding: 5px 0px;
    }
    .countdown-imgblock-wrapper {
      padding: 3px 0px;
    }
  }
  @media screen and (max-width: 320px) {
      .timer {
      font-size: 28px;
    }
  }
</style>



// WEBPACK FOOTER //
// CountdownPLP.vue?32d0f8a4